import { InsightCard } from "@/components/InsightCard";
import { useHomeShared } from "./HomeShared";

/**
 * ef-061-4 — the Home "Needs you" tile: the uncategorized-receipts insight, counted from the ledger plus what
 * has arrived this session (shared Home state).
 *
 * No `onReview`, and that is InsightCard's own rule rather than a regression: "a card with nowhere to go
 * should not offer a control that does nothing". The receipts it names are on this screen, so "Review →"
 * would navigate from here to here.
 */
export function NeedsYouTile() {
  const { uncategorizedReceiptCount, uncategorizedReceiptTotal } = useHomeShared();
  return (
    <InsightCard uncategorizedCount={uncategorizedReceiptCount} uncategorizedTotal={uncategorizedReceiptTotal} />
  );
}
